import { render, staticRenderFns } from "./ContentNotes.vue?vue&type=template&id=0f38557e&scoped=true"
import script from "./ContentNotes.vue?vue&type=script&lang=js"
export * from "./ContentNotes.vue?vue&type=script&lang=js"
import style0 from "./ContentNotes.vue?vue&type=style&index=0&id=0f38557e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f38557e",
  null
  
)

export default component.exports